import { Sparkles, Shield, Crown, Wallet } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

const icons = [Sparkles, Shield, Crown, Wallet];

export default function WhyMoissanite() {
  const { t } = useLanguage();
  const c = t.why.comparison;

  return (
    <section id="why-moissanite" data-testid="why-section" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-5xl px-5 lg:px-10">
        <Reveal className="mb-12 text-center">
          <span className="eyebrow text-[11px] text-[#999]">{t.nav.whyMoissanite}</span>
          <h2 className="mt-3 font-serif-display text-3xl font-medium text-[#111] sm:text-4xl">{t.why.title}</h2>
          <p className="mx-auto mt-3 max-w-md font-body text-sm text-[#777]">{t.why.subtitle}</p>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          {t.why.benefits.map(([title, text], i) => {
            const Icon = icons[i] || Sparkles;
            return (
              <Reveal key={title} delay={i * 0.08}>
                <div data-testid={`why-benefit-${i}`} className="flex gap-4 rounded-2xl border border-[#eee] bg-[#f7f7f5] p-6">
                  <Icon className="h-6 w-6 shrink-0 text-[#111]" strokeWidth={1.3} />
                  <div>
                    <h3 className="font-body text-base font-medium text-[#111]">{title}</h3>
                    <p className="mt-1 font-body text-sm text-[#777]">{text}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-14">
          <h3 className="mb-5 text-center font-serif-display text-xl text-[#111]">{t.why.comparisonTitle}</h3>
          <div className="overflow-hidden rounded-2xl border border-[#eee]">
            <div className="grid grid-cols-3 bg-[#f7f7f5]">
              {c.headers.map((h, i) => (
                <div
                  key={i}
                  className={`p-4 font-body text-xs font-semibold uppercase tracking-wider ${
                    i === 2 ? "text-[#111]" : "text-[#888]"
                  }`}
                >
                  {h}
                </div>
              ))}
            </div>
            {c.rows.map((row, ri) => (
              <div key={ri} data-testid={`comparison-row-${ri}`} className="grid grid-cols-3 border-t border-[#eee]">
                <div className="p-4 font-body text-sm font-medium text-[#333]">{row[0]}</div>
                <div className="p-4 font-body text-sm text-[#888]">{row[1]}</div>
                <div className="bg-[#faf9f7] p-4 font-body text-sm text-[#111]">{row[2]}</div>
              </div>
            ))}
          </div>
          <p className="mt-4 text-center font-body text-xs italic leading-relaxed text-[#999]">{c.note}</p>
        </Reveal>
      </div>
    </section>
  );
}
